export class HtmlService {
  public static clearEscapeSymbols(str = ''): string {
    return str.replace(/\\"/g, '"');
  }
}
